import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const ROUTES = {
  WORKPLACE_LIST: 'miscellaneous-workplace'
}

const routes = [
  {
    path: 'workplace/',
    name: ROUTES.WORKPLACE_LIST,
    beforeEnter: beforeEnter,
    props: true,
    meta: {
      permissions: ['miscellaneous_workplace_list'],
      requiresAuth: true
    },
    component: () => import('./WorkplaceList.vue')
  }

]

export { routes, ROUTES }
